module.exports = __webpack_public_path__ + "img/banzhenbz.f4ad5e6c.png";